export const CHANGE_SERVICES_EVENT_NAME = 'fvu-mf-change-services';
export const FVU_CHECK_SERVICE_STATUS_CHANGE_EVENT_NAME = 'fvu-mf-check-service-status-change';
export const PUBLICATION_UNAVAILABLE_EVENT_NAME = 'fvu-mf-publication-unavailable';
